/**
 * Core data create: POST _data/{portfolio}/{org}/{ring}.
 * Uses portfolio/org from config. Backend refreshes S3 cache after POST.
 */

import { getAuthHeaders, buildDataUrl } from './request';

export interface PostRingResponse<T = Record<string, unknown>> {
  success: boolean;
  message?: string;
  path?: string;
  item?: T & { _id: string };
  error?: string;
}

/**
 * Creates a new document in a ring. Payload must match blueprint fields (e.g. required fields).
 * Returns the created item with _id on success.
 */
export async function postRing<T = Record<string, unknown>>(
  ring: string,
  payload: Record<string, unknown>
): Promise<PostRingResponse<T>> {
  const url = buildDataUrl(ring);
  const headers = await getAuthHeaders();
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const data = (await res.json().catch(() => ({}))) as PostRingResponse<T>;
  if (!res.ok) {
    throw new Error(
      (data?.error as string) || (data?.message as string) || `HTTP ${res.status}`
    );
  }
  return data;
}
